import { useEffect, useState, useMemo } from 'react';

export const useMounted = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);
  return useMemo(() => isMounted, [isMounted]);
};
